<!-- <div class="body__content">
  <div class="body__button">
    <h4>Equipo</h4>
    <p>Quiero agregar un nuevo equipo a mi licencia.</p>
  </div> -->
<div class="body__option container-body-options" [ngClass]="{
  'show': selectedOption === 'EQUIPMENT',
  'hide': selectedOption !== 'EQUIPMENT',
  'inputs-white': colorInputs === 'WHITE'
}">
  <div class="row" style="padding-bottom: 10px;">
    <div class="col-12 col-md-4">
      <div class="form form--required">
        <label for="" class="label">
          {{ emptyTitles ? '-' : 'Tipo de equipo' }} <app-tooltip text="Vehiculo que conducirá."></app-tooltip>
        </label>
        <select [formControl]="asFormControl(newEquipmentForm.controls.vehicleType)">
          <option value="">Seleccionar</option>
          <option *ngFor="let vehicleType of vehicleTypesToList; index as i;" value="{{vehicleType.id}}">
            {{vehicleType.name}} </option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-4" *ngFor="let control of [asFormControl(newEquipmentForm.controls.brand)]">
      <div class="form" [ngClass]="control.validator?.length ? 'form--required' : ''">
        <label for="" class="label">
          {{ emptyTitles ? '-' : 'Marca equipo' }} <app-tooltip text="Fabricante del equipo."></app-tooltip>
        </label>
        <input type="text" placeholder="Ingresar" [formControl]="control">
      </div>
    </div>
    <div class="col-12 col-md-4" *ngFor="let control of [asFormControl(newEquipmentForm.controls.model)]">
      <div class="form" [ngClass]="control.validator?.length ? 'form--required' : ''">
        <label for="" class="label">
          {{ emptyTitles ? '-' : 'Modelo equipo' }} <app-tooltip text="Numero o codigo del modelo identificador del equipo">
          </app-tooltip>
        </label>
        <input type="text" placeholder="Ingresar" [formControl]="control">
      </div>
    </div>
  </div>
  <div class="row body__row--two" style="padding-bottom: 10px;">
    <div class="col-12 col-md-4 body__col">
      <div class="form form--required">
        <label for="" class="label astObliGatoriEquip">
          {{ emptyTitles ? '-' : 'Tipo de licencia' }}
          <span class="bhptooltip align-middle ml-3"
            data-text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris non erat lacus. Phasellus suscipit ut ante quis commodo.">
          </span>
        </label>
        <div class="form__check mb-2" *ngFor="let item of licenseTypes; index as i;">
          <input type="checkbox" id="opt1{{item.name}}{{item.id}}"
            [formControl]="asFormControl(getCheckControls(item.id!, 'LICENSE_TYPE').active)">
          <label for="opt1{{item.name}}{{item.id}}">
            <div class="fakebox"></div>
            {{ item.name }}
          </label>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 body__col">
      <div class="form form--required">
        <label for="" class="label astObliGatoriEquipForZones">
          {{ emptyTitles ? '-' : 'Zonas de conducción' }}
          <span class="bhptooltip align-middle ml-3"
            data-text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris non erat lacus. Phasellus suscipit ut ante quis commodo.">
          </span>
        </label>
        <div class="d-flex">
          <div class="mr-5">
            <ng-container *ngFor="let item of conductionZones | slice: 0 : conductionZonesSlice ;index as i">
              <div class="form__check mb-2" [ngClass]="{'global-unmount': getCheckControls(item.id, 'ZONES').isHidden.value}">
                <input type="checkbox" id="{{item.name}}{{item.id}}"
                  [formControl]="asFormControl(getCheckControls(item.id!, 'ZONES').active)"
                  [attr.disabled]="!getCheckControls(item.id).isEnabled.value ? true : null"
                  [ngClass]="{'no-pointer-events': !getCheckControls(item.id).isEnabled.value}">
                <label for="{{item.name}}{{item.id}}"
                  [ngClass]="{'no-pointer-events': !getCheckControls(item.id).isEnabled.value}">
                  <!-- <div class="fakebox"></div>
                    {{ item.name }} -->
                  <div class="fakebox" [ngClass]="{
                        'dark-grey-bg': !getCheckControls(item.id!, 'ZONES').isEnabled.value,
                        'no-pointer-events': !getCheckControls(item.id).isEnabled.value
                      }"></div>
                  {{ item.name }}
                </label>
              </div>
            </ng-container>
          </div>
          <div>
            <ng-container *ngFor="let item of conductionZones | slice: conductionZonesSlice : conductionZones.length ;index as i">
            <div
              class="form__check mb-2"
              [ngClass]="{'global-unmount': getCheckControls(item.id, 'ZONES').isHidden.value}"
            >
              <input type="checkbox" id="{{item.name}}{{item.id}}"
                [formControl]="asFormControl(getCheckControls(item.id!, 'ZONES').active)">
              <label for="{{item.name}}{{item.id}}">
                <div class="fakebox"></div>
                {{ item.name }}
              </label>
            </div>
          </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button type="button" class="btn btn--primary px-5" [disabled]="newEquipmentForm.valid ? false : true"
    (click)="onAddNewEquipment()"> {{ emptyTitles ? '-' : 'Ingresar equipo' }}</button>
</div>
<!-- </div> -->
